import BaseObject from "../../models/BaseObject";
import { ChannelType, channelTypeInfo } from "../../models/ChannelType";
import type Consumer from "../../models/Consumer";
import { copyAllProperties } from "../../models/utils";
import { PanelKnxSignal } from "./PanelKnxSignal";
import Room from "../../models/Room";

const jalousieNames = ["jalousie", "jalousien", "blind", "rolladen", "rollade", "rollo", "shutter"]; // no itx

const lightNames = ["lampe", "light", "leuchte", "beleuchtung"]; // no itx

function stripName(name: string, stripNames: Array<string>): string {
  stripNames.forEach((stripName) => {
    const p = name.toLocaleLowerCase().indexOf(stripName);
    if (p >= 0) {
      const name1 = name.substring(0, p);
      const name2 = name.substring(p + stripName.length);
      name = name1.trim() + " " + name2.trim();
      name = name.trim();
    }
  });

  if (name.endsWith("/")) {
    name = name.substr(0, name.length - 1);
  }

  return name;
}

export type PanelKnxInfo = {
  //
  // Switch
  //

  Switch?: PanelKnxSignal;
  SwitchStatus?: PanelKnxSignal;

  //
  // Dimmer
  //

  DimValue?: PanelKnxSignal;
  DimValueStatus?: PanelKnxSignal;

  DimStep?: PanelKnxSignal;

  ColorTemperaturePercentColdWhite?: PanelKnxSignal;
  ColorTemperaturePercentColdWhiteStatus?: PanelKnxSignal;

  //
  // Heating
  //

  Temperature_Current?: PanelKnxSignal;

  Temperature_Target?: PanelKnxSignal;
  Temperature_TargetStatus?: PanelKnxSignal;

  Temperature_TargetStep_1?: PanelKnxSignal;
  Temperature_TargetStep_9?: PanelKnxSignal;

  ValveStateStatus?: PanelKnxSignal;

  //
  // Jalousie Blind
  //

  BlindMove?: PanelKnxSignal;
  BlindStopStep?: PanelKnxSignal;

  BlindPosition?: PanelKnxSignal;
  BlindPositionStatus?: PanelKnxSignal;
  BlindTopStatus?: PanelKnxSignal;
  BlindBottomStatus?: PanelKnxSignal;

  SlatPosition?: PanelKnxSignal;
  SlatPositionStatus?: PanelKnxSignal;

  /// ab hier muß noch refatored werden  !!!! mwe 20.3.2024
  //
  ////////////////////////////////////////////
  SendValue2?: PanelKnxSignal;
  ReceiveValue2?: PanelKnxSignal;

  Bewegen?: PanelKnxSignal;

  Stop?: PanelKnxSignal;
  Stop_dpt?: PanelKnxSignal;

  ReceiveOben?: PanelKnxSignal;
  ReceiveUnten?: PanelKnxSignal;

  Scene?: PanelKnxSignal;
};

export default class PanelDevice extends BaseObject {
  public get className(): string {
    return "PanelDevice"; // no itx
  }

  label2: string = "";
  type: "Switch" | "Dimmer" | "TuneableWhite" | "String" | "Time" | "" = ""; // no itx

  delayOnChangeTimer: any | undefined;
  knx: PanelKnxInfo | undefined;
  ui_readonly = false;

  // Only for Variables, not for KNX Datapoints
  varValue?: any;

  min = 0;
  max = 100;
  step = 10;

  unit?: string;

  //////////////////////////////////////////////////////////////////////////

  sceneNumberBase = 0;
  pressedIdx: string = "";
  consumer?: Consumer;

  consumerId: string = "";

  //////////////////////////////////////////////////////////////////////////

  getPersistentProperties(): string[] {
    return ["type", "knx", "consumerId", ...super.getPersistentProperties()]; // no itx
  }

  _delayOnChangeEvents = 0; // delay in millisecounds
  set delayOnChangeEvents(val: number) {
    this._delayOnChangeEvents = val;
  }

  get delayOnChangeEvents(): number {
    return this._delayOnChangeEvents;
  }

  //////////////////////////////////////////////////////////////////////////

  constructor(data: any) {
    super(data);

    copyAllProperties(data, this);

    if (this.knx) {
      if (this.knx.DimValue || this.knx.Switch) {
      } else {
        this.ui_readonly = true;
      }
    }
  }

  fireOnChange = (value: any, property: string) => {
    this.onChange.raise({ property: property, value: value }, undefined);
  };

  gotDataFromServer = (groupAddress: string, value: any, property: string) => {
    try {
      if (typeof value == "string") {
        value = value.toLocaleLowerCase();
      }

      if (property === "SwitchStatus") {
        if (value === "inactive" || value === "off" || value === "false" || parseInt(value) === 0) {
          value = false;
        } else if (value === "active" || value === "on" || value === "true" || parseInt(value) === 1) {
          value = true;
        } else {
          console.log(`"gotDataFromServer INVALID SwitchStatus ${this.name} ${groupAddress} value=<${value}>`);
          return;
        }
      } else {
        if (this.type === "String" || this.type === "Time") {
          // value = value;
        } else {
          const v = parseFloat(value);
          if (isNaN(v)) {
            console.log(
              `"gotDataFromServer INVALID VALUE ${this.name} ${groupAddress} value=<${value}> property=${property}`,
            );
            return;
          } else {
            value = v;
          }
        }
      }

      if (this.knx) {
        const signal = (this.knx as any)[property] as PanelKnxSignal;
        if (signal) {
          signal.lastValue = value;
          signal.received = true;
        }
      }

      this.fireOnChange(value, property);

      // if (true) {
      //   // value !== this[property] || !this.gotAck) {
      //   console.log(`gotDataFromServer ${this.name} ${groupAddress} ${value} ${property}`);

      //   if (this.gotAck && (this as any)[property] == value) {
      //     return;
      //   }

      //   this.gotAck = true;
      //   (this as any)[property] = value;

      //   if (this.delayOnChangeEvents) {
      //     if (this.delayOnChangeTimer) {
      //       clearTimeout(this.delayOnChangeTimer);
      //       this.delayOnChangeTimer = 0;
      //     }
      //     this.delayOnChangeTimer = setTimeout(() => {
      //       this.fireOnChange(value, property);
      //     }, this.delayOnChangeEvents);
      //   } else {
      //     this.fireOnChange(value, property);
      //   }
      // } else {
      //   console.log(`"gotDataFromServer ${this.name} UNCHANGED`);
      // }
    } catch (ex) {
      console.error("gotDataFromServer", ex);
    }
  };

  // get isTuneableWhite() {
  //   return this.knx?.SendValue2 !== undefined;
  // }

  // startScene(sceneNumber: number) {
  //   this.value = -1; // force send
  //   this.setValue(sceneNumber - 1); // Scene Numbers are "-1" in knx
  // }

  // saveScene(sceneNumber: number) {
  //   console.log(`Save Scene: ${sceneNumber}`);
  //   const SPEICHERN = 0x80;
  //   this.value = -1; // force send
  //   this.setValue(sceneNumber - 1 + SPEICHERN); // Scene Numbers are "-1" in knx
  // }

  setValueGeneric = (signal: PanelKnxSignal | undefined, value: number | boolean) => {
    if (signal) {
      console.log(`setValueGeneric ${this.name} ${value} ${signal.ga} ${signal.dpt}`);

      signal.lastValue = value;

      const data = {
        command: "write", // no itx
        data: {},
      };

      let dpst = signal.dpt.toLocaleUpperCase();

      if (!dpst.startsWith("DPST")) {
        dpst = "DPST-" + dpst;
      }

      data.data = {
        groupAddress: signal.ga,
        dptType: dpst,
        value: `${value}`,
      };

      (window as any).sendToSocketServer(data);
    } else {
      console.error("undefined signal");
    }
  };

  setVarValue = (value: number) => {
    console.log(`setVarValue ${this.name} ${value} `);

    this.varValue = value;

    const data = {
      command: "write", // no itx
      data: {
        var: this.name,
        value: value,
      },
    };

    (window as any).sendToSocketServer(data);
  };

  // jalousieMove = (value: number) => {
  //   this.gotAck = false;

  //   if (this.knx?.Bewegen) {
  //     const data = {
  //       command: "write",
  //       data: {
  //         groupAddress: this.knx?.Bewegen.ga,
  //         dptType: this.knx?.Bewegen.dpt,
  //         value: value,
  //       },
  //     };

  //     // if (value !== this.value) {
  //     //   this.value = value;
  //     //   //   this.fireOnChange(value, "value");
  //     // }

  //     (window as any).sendToSocketServer(data);
  //   }
  // };

  // jalousieStopStep = (value: number) => {
  //   if (this.knx?.Stop) {
  //     this.gotAck = false;
  //     if (this.knx) {
  //       const data = {
  //         command: "write",
  //         data: {
  //           groupAddress: this.knx.Stop.ga,
  //           dptType: this.knx.Stop_dpt,
  //           value: value,
  //         },
  //       };

  //       (window as any).sendToSocketServer(data);
  //     }
  //   }
  // };

  // setValue2 = (value2: number) => {
  //   this.gotAck = false;
  //   if (this.knx?.SendValue2) {
  //     const data = {
  //       command: "write",
  //       data: {
  //         groupAddress: this.knx.SendValue2.ga,
  //         dptType: this.knx.SendValue2.dpt,
  //         value: value2,
  //       },
  //     };

  //     if (value2 !== this.value2) {
  //       this.value2 = value2;
  //       //  this.fireOnChange(value2, "value2");
  //     }

  //     (window as any).sendToSocketServer(data);
  //   }
  // };

  // setSwitch = (newValue: boolean) => {
  //   if (this.knx?.Switch) {
  //     var data = {
  //       command: "write",
  //       data: {},
  //     };

  //     console.log(`setSwitch ${ this.name } ${ newValue } `);

  //     if (this.knx) {
  //       data.data = {
  //         groupAddress: this.knx.Switch.ga,
  //         dptType: "DPST-" + this.knx.Switch.dpt || "DPST-1-1",
  //         value: newValue,
  //       };
  //     } else {
  //       data.data = {
  //         var: this.name,
  //         value: newValue,
  //       };
  //     }

  //     if (newValue !== this.switchStatus) {
  //       this.switchStatus = newValue;
  //       this.gotAck = false;
  //       this.fireOnChange(newValue, "SwitchStatus");
  //     } else {
  //       // just to make sure we are consistent
  //       // this.fireOnChange(SwitchStatus, "SwitchStatus");
  //     }

  //     (window as any).sendToSocketServer(data);
  //   }
  // };

  requestUpdate = () => {
    if (this.knx) {
      var data = {
        command: "requestUpdate", // no itx
        data: {},
      };

      if (this.knx) {
        data.data = {
          groupAddresses: [this.knx.SwitchStatus, this.knx.DimValueStatus, this.knx.ReceiveValue2],
        };
      } else {
        data.data = {
          vars: [this.name],
        };
        (window as any).sendToSocketServer(data);
      }
    }
  };

  static fromConsumer(consumer: Consumer, index?: number): PanelDevice {
    const info = channelTypeInfo(consumer.channelType);

    //
    // Light
    //
    if (info.isLight) {
      let type = "Switch"; // no itx

      switch (consumer.channelType) {
        case ChannelType.Dimmer:
          type = "Dimmer"; // no itx
          break;

        case ChannelType.TuneableWhite:
          type = "Tuneablewhite"; // no itx
          break;
      }

      //
      // Wenn der Name im Panel editiert wurde, wird dieser verwendet
      //

      let name = consumer.extData?.panel?.name || "";

      if (name == "") {
        name = consumer.name || consumer.tag;
        name = stripName(name, lightNames);
        if (consumer.parent) {
          name = stripName(name, [consumer.parent.name.toLocaleLowerCase()]);
        }

        /////////////////////////////////////////////////////////////////////////////////
        //
        // falls der Consumer mit einem ButtonChannel verbunden ist an dem eine Name gesezt ist,
        // wird dieser Name verwendet, da der dann editiert wurde zur Darstellung auf dem Button
        // und somt wahrscheinlich besser passt.
        //

        const buttonChannels = consumer.connections.findAsArray(
          (c) => c.getPartner(consumer)?.className == "BUttonChannel",
        );
        buttonChannels.forEach((channel) => {
          if (channel.name != "") {
            name = channel.name;
          }
        });
      }

      /////////////////////////////////////////////////////////////////////////////////

      const item: PanelDevice = new PanelDevice({
        id: `L - ${index || 0} `,
        name: name,
        type: type,
        consumer: consumer,
        consumerId: consumer.id,
      });

      return item;
    }

    //
    // Heating
    //

    if (consumer.channelType == ChannelType.Heating) {
      const item: PanelDevice = new PanelDevice({
        id: `T - ${index || 0} `,
        name: consumer.parent?.name || consumer.parent?.tag,
        type: "Temperatur",
        consumer: consumer,
        consumerId: consumer.id,
      });
      return item;
    }

    //
    // Jalousie / Blind
    //

    if (consumer.channelType == ChannelType.Jalousie || consumer.channelType == ChannelType.Blind) {
      let name = consumer.parent?.nameOrTag;

      const numberOfJalousies = (consumer.parent as Room)?.consumers.findAsArray(
        (c) => c.channelType == consumer.channelType,
      ).length;
      if (numberOfJalousies > 1) {
        name = name + "\n" + consumer.nameOrTag;
      }

      name = stripName(name || "", jalousieNames);

      const item: PanelDevice = new PanelDevice({
        id: `J - ${index || 0} `,
        name: name,
        type: "Jalousie",
        consumer: consumer,
        consumerId: consumer.id,
      });
      return item;
    }

    this.logger.error(`Consumer type not implemented ${consumer.channelType}`);
    return new PanelDevice({
      id: `xx - ${index || 0} `,
      name: `not implemented ${consumer.channelType}`,
      type: "Switch",
      consumer: consumer,
    });
  }
}
